export default __webpack_public_path__ + "static/media/suprise.cce679da.png";